import { isToday } from 'utils/date';

export const formatNotifications = (list = []) => {
  const listWithDates = list.map((notification) => ({
    ...notification,
    time: getTimeAMPMFormat(new Date(notification.creationTime)),
    date: getDateInNotificationFormat(
      new Date(notification.creationTime),
      true
    ),
    jsonMessage: JSON.parse(notification.message),
  }));
  const uniqueDates = listWithDates.reduce((acc, { creationTime, date }) => {
    const dateObject = new Date(creationTime);
    const formattedDate = getDateInNotificationFormat(dateObject);
    const isTodaysDate = isToday(dateObject);
    const returnDate = isTodaysDate ? 'Today' : formattedDate;
    return { ...acc, [date]: returnDate };
  }, {});

  const notificationList = listWithDates.reduce((acc, notification) => {
    if (acc[notification.date]) {
      return {
        ...acc,
        [notification.date]: [...acc[notification.date], notification],
      };
    }

    return { ...acc, [notification.date]: [notification] };
  }, {});

  return { dates: uniqueDates, list: notificationList };
};

const getDateInNotificationFormat = (date, sendInNormalFormat = false) => {
  const months = [
    '',
    'Jan',
    'Feb',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'Oct',
    'Nov',
    'Dec',
  ];

  const d = date.getDate();
  const m = date.getMonth();
  const y = date.getFullYear();

  const suffix = getNumberSuffix(d);

  if (sendInNormalFormat) {
    return `${d}-${m}-${y}`;
  }
  return `${suffix} ${months[m]} ${y}`;
};

const getNumberSuffix = (i) => {
  const j = i % 10;
  const k = i % 100;

  if (j === 1 && k !== 11) {
    return i + 'st';
  }

  if (j === 2 && k !== 12) {
    return i + 'nd';
  }

  if (j === 3 && k !== 13) {
    return i + 'rd';
  }

  return i + 'th';
};

const getTimeAMPMFormat = (date) => {
  let hours = date.getHours();
  let minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  hours = hours < 10 ? '0' + hours : hours;
  // appending zero in the start if hours less than 10
  minutes = minutes < 10 ? '0' + minutes : minutes;
  return hours + ':' + minutes + ' ' + ampm;
};
